.root {
  color: var(--color-white);

  > :last-child:not(:first-child) {
    margin-left: 2px;
  }

  &.fullWidth {
    display: flex;
    justify-content: center;
  }
}
